var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBotijaoP13Branco(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 38,
    viewBox: "0 0 26 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "botijao-p13-cinza.536da488",
    transform: "translate(-1357 -2175.853)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4",
    "data-name": "Grupo 4",
    transform: "translate(1357 2176)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3",
    "data-name": "Grupo 3",
    transform: "translate(4 -0.147)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_594",
    "data-name": "Caminho 594",
    d: "M15,33.5H3A1.5,1.5,0,0,1,1.5,32V3A1.5,1.5,0,0,1,3,1.5H15A1.5,1.5,0,0,1,16.5,3V32A1.5,1.5,0,0,1,15,33.5ZM5.177,1.681a3.5,3.5,0,0,0-3.5,3.5V18.151a3.5,3.5,0,0,0,3.5,3.5h7.646a3.5,3.5,0,0,0,3.5-3.5V5.182a3.5,3.5,0,0,0-3.5-3.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_595",
    "data-name": "Caminho 595",
    d: "M15,32l0,0V22.652a4.97,4.97,0,0,1-2.177.5H5.177A4.972,4.972,0,0,1,3,22.652V32l0,0H15m0,3H3a3,3,0,0,1-3-3V3A3,3,0,0,1,3,0H15a3,3,0,0,1,3,3V32A3,3,0,0,1,15,35ZM5.177,3.181a2,2,0,0,0-2,2V18.151a2,2,0,0,0,2,2h7.646a2,2,0,0,0,2-2V5.182a2,2,0,0,0-2-2Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_63",
    "data-name": "Ret\\xE2ngulo 63",
    width: 26,
    height: 30,
    rx: 5,
    transform: "translate(0 5.853)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_64",
    "data-name": "Ret\\xE2ngulo 64",
    width: 18,
    height: 5,
    transform: "translate(4 32.853)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_596",
    "data-name": "Caminho 596",
    d: "M0,0H18.926",
    transform: "translate(1360.68 2196.503)",
    fill: "rgba(62,131,248,0)",
    stroke: "#000FFF",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBotijaoP13Branco);
export default __webpack_public_path__ + "static/media/botijao-p13-branco.0a286e6a22febe485e780dec43ab674e.svg";
export { ForwardRef as ReactComponent };